import { render, staticRenderFns } from "./MergeView.vue?vue&type=template&id=5825cb2e&scoped=true"
import script from "./MergeView.ts?vue&type=script&lang=ts&external"
export * from "./MergeView.ts?vue&type=script&lang=ts&external"
import style0 from "./MergeView.vue?vue&type=style&index=0&id=5825cb2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5825cb2e",
  null
  
)

export default component.exports